import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

const useAddFavoriteForumMutation = getWrappedUseMutation(apiClient.UsersPreferences.put);

const useRemoveFavoriteForumMutation = getWrappedUseMutation(apiClient.UsersPreferences.delete);

export { useAddFavoriteForumMutation, useRemoveFavoriteForumMutation };
